import React, { useState } from 'react';
import { Box, CardActionArea, Grid, Typography } from '@mui/material';
import CustomButton from '../../../components/UI/CustomButton';
import CustomTable from '../../../components/UI/CustomTable';
import { CellType } from '../../../types/Common';
import { getReportByType } from '../../../apis/report';
import { ECliftonList } from '../../../constants/translate';
import useStyles from './useStyles';

const tableHead = [
  {
    key: 'row',
    label: 'ردیف',
    type: CellType.ROW,
  },
  {
    key: 'name',
    label: 'نام',
    type: CellType.STRING,
  },
  {
    key: 'lastName',
    label: 'نام خانوادگی',
    type: CellType.STRING,
  },
  {
    key: 'result',
    label: 'نمره',
    type: CellType.FLOAT,
  },
  {
    key: 'testDate',
    label: 'تاریخ انجام آزمون',
    type: CellType.DATE,
  },
  {
    key: 'testId',
    label: 'مشاهده نتیجه آزمون',
    type: CellType.TEST,
  },
];

const Clifton = () => {
  const classes = useStyles();
  const [selectValue, setSelectValue] = useState('');
  const [selectEValue, setSelectEValue] = useState('');
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);

  const getReport = () => {
    setLoading(true);
    getReportByType('clifton', `${selectValue}-${selectEValue}`)
      .then((res: any) => setUsers(res || []))
      .catch((e) => console.log({ e }))
      .finally(() => setLoading(false));
  };

  return (
    <>
      <Box className={classes.topContainer}>
        <Grid container mt={2} spacing={1}>
          {ECliftonList.map((item) => (
            <Grid item lg={1} key={item.name}>
              <CardActionArea
                onClick={() => {
                  setSelectEValue(item.value);
                  setSelectValue(item.parentValue);
                }}
                sx={{ borderRadius: '0.5rem' }}
              >
                <Box
                  className={classes.boxContainer}
                  sx={{
                    backgroundColor: item.value === selectEValue ? '#FFF1E6' : 'translate',
                    borderColor: item.value === selectEValue ? '#FF6B00' : '#DCDFE1',
                  }}
                >
                  <Typography color='text.main'>{item.name}</Typography>
                </Box>
              </CardActionArea>
            </Grid>
          ))}
        </Grid>

        <Box className={classes.header}>
          <CustomButton
            loading={loading}
            disabled={loading || !selectValue || !selectEValue}
            onClick={getReport}
          >
            <Typography px={2}>اعمال فیلتر</Typography>
          </CustomButton>
        </Box>
      </Box>

      <Box mt={2}>
        <CustomTable rows={users} tableHead={tableHead} size='small' />
      </Box>
    </>
  );
};

export default Clifton;
